import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';

// โหลดสคริปต์ Google Identity Services ครั้งเดียว (cache promise)
let _gisPromise = null;
function loadGis() {
    if (_gisPromise) return _gisPromise;
    _gisPromise = new Promise((resolve, reject) => {
        if (window.google && window.google.accounts && window.google.accounts.id) {
            return resolve(window.google);
        }
        const s = document.createElement('script');
        s.src = 'https://accounts.google.com/gsi/client';
        s.async = true;
        s.defer = true;
        s.onload = () => {
            if (window.google && window.google.accounts && window.google.accounts.id) resolve(window.google);
            else reject(new Error('โหลด Google ไม่สำเร็จ'));
        };
        s.onerror = () => reject(new Error('โหลด Google ไม่สำเร็จ'));
        document.head.appendChild(s);
    });
    return _gisPromise;
}

// อ่าน Google Client ID จาก /api/branding (public) ครั้งเดียว
let _clientIdPromise = null;
function getClientId() {
    if (_clientIdPromise) return _clientIdPromise;
    _clientIdPromise = api.get('/branding')
        .then(res => (res.data && res.data.google_client_id) ? String(res.data.google_client_id).trim() : '')
        .catch(() => '');
    return _clientIdPromise;
}

/**
 * ปุ่ม Google (ใช้ทั้งหน้า Login และหน้า Profile)
 *  props:
 *    onCredential(idToken)  - callback เมื่อผู้ใช้ยืนยันกับ Google สำเร็จ (ได้ ID token)
 *    text                   - 'signin_with' | 'continue_with' (ข้อความบนปุ่ม)
 *    onUnavailable()        - เรียกเมื่อยังไม่ได้ตั้งค่า Client ID (ซ่อนปุ่มได้)
 */
function GoogleButton({ onCredential, text = 'signin_with', onUnavailable }) {
    const ref = useRef(null);
    const cbRef = useRef(onCredential);
    cbRef.current = onCredential;
    const unavailRef = useRef(onUnavailable);
    unavailRef.current = onUnavailable;
    const [ready, setReady] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const clientId = await getClientId();
                if (cancelled) return;
                if (!clientId) {
                    setError('unavailable');
                    if (unavailRef.current) unavailRef.current();
                    return;
                }
                const google = await loadGis();
                if (cancelled || !ref.current) return;
                google.accounts.id.initialize({
                    client_id: clientId,
                    callback: (resp) => { if (resp && resp.credential) cbRef.current(resp.credential); },
                    ux_mode: 'popup',
                    auto_select: false
                });
                ref.current.innerHTML = '';
                google.accounts.id.renderButton(ref.current, {
                    theme: 'outline',
                    size: 'large',
                    type: 'standard',
                    text,
                    shape: 'pill',
                    logo_alignment: 'left',
                    width: 260
                });
                setReady(true);
            } catch (e) {
                if (!cancelled) setError(e.message || 'โหลด Google ไม่สำเร็จ');
            }
        })();
        return () => { cancelled = true; };
    }, [text]);

    if (error === 'unavailable') return null; // ยังไม่ได้ตั้งค่า Client ID — ไม่แสดงปุ่ม
    return (
        <div className="google-btn-wrap">
            <div ref={ref}></div>
            {!ready && !error && <div className="google-btn-loading">กำลังโหลด Google…</div>}
            {error && error !== 'unavailable' && <div className="google-btn-error">{error}</div>}
        </div>
    );
}

export default GoogleButton;
